import { Injectable } from '@angular/core';

// PEC e scopo mutualistico non sono più validator: in InfoPath sono avvisi non bloccanti (vedi ConclusioniWarningsService).
// Il blocco reale è nelle regole my_CkProposte_PEC / my_CkProposte_scopoMutual (conclusioni-ck-proposte.rules.ts).
@Injectable()
export class ConclusioniFieldValidators {}
